import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Login from './views/Login.vue';

import DepartmentList from './views/department/List.vue';
import DepartmentDetail from './views/department/Detail.vue';

import ProductList from './views/product/List.vue';
import ProductDetail from './views/product/Detail.vue';

import ProductReleaseDetail from './views/product-release/Detail.vue';

import ItemTypesList from './views/itemtypes/List.vue';
import ItemTypesDetail from './views/itemtypes/Detail.vue';

import ItemGroupList from './views/itemgroup/List.vue';
import ItemGroupDetail from './views/itemgroup/Detail.vue';

import ReleaseFlowList from './views/release-flow/List.vue';
import ReleaseFlowDetail from './views/release-flow/Detail.vue';
import ReleaseStepDetail from './views/release-flow/Step.vue';

import UserList from './views/user/List.vue';
import UserDetail from './views/user/Detail.vue';

import TaskList from './views/task/List.vue';

import ReleaseList from './views/releases/List.vue';
import ReleaseDetail from './views/releases/Detail.vue';
import ReleaseNew from './views/releases/New.vue';
import ReleaseOpen from './views/releases/Open.vue';
import ReleaseStepHistory from './views/releases/StepHistory.vue';

import store from './store';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
        },
        {
            path: '/product-list',
            name: 'product-list',
            component: ProductList,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/product-detail/:id?',
            name: 'product-detail',
            component: ProductDetail,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/product-release-detail',
            name: 'product-release-detail',
            component: ProductReleaseDetail,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/department-list',
            name: 'department-list',
            component: DepartmentList,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/department-detail/:id?',
            name: 'department-detail',
            component: DepartmentDetail,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/itemgroup-list',
            name: 'itemgroup-list',
            component: ItemGroupList,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/itemgroup-detail/:id?',
            name: 'itemgroup-detail',
            component: ItemGroupDetail,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/release-flow-list',
            name: 'release-flow-list',
            component: ReleaseFlowList,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/release-flow-detail/:id?',
            name: 'release-flow-detail',
            component: ReleaseFlowDetail,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/release-step-detail/:flowid/:id?',
            name: 'release-step-detail',
            component: ReleaseStepDetail,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/release-list',
            name: 'release-list',
            component: ReleaseList,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/release-new',
            name: 'release-new',
            component: ReleaseNew,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/release-step-history/:id',
            name: 'release-step-history',
            component: ReleaseStepHistory,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/release-detail/:id?',
            name: 'release-detail',
            component: ReleaseDetail,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/release-open/',
            name: 'release-open',
            component: ReleaseOpen,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/itemtypes-list',
            name: 'itemtypes-list',
            component: ItemTypesList,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/itemtypes-detail/:id?',
            name: 'itemtypes-detail',
            component: ItemTypesDetail,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/user-list',
            name: 'user-list',
            component: UserList,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/user-detail/:id?',
            name: 'user-detail',
            component: UserDetail,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/task-list',
            name: 'task-list',
            component: TaskList,
            meta: {
                requiresAuth: true
            }
        }
    ],
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            next();
            return;
        }
        next('/login');
    } else {
        next();
    }
});

export default router;
